<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from "vue-router"
import { mdiMenu } from "@mdi/js"
import SvgIcon from "@jamescoyle/vue-icon"
import { buildNavigationItems, DOCK_ROUTE_NAME_SET, DOCK_ROUTE_NAMES, type NavigationItem } from "./navigation"
import { useAppContext } from "../../AppContext"
import { badgeFor } from "../../community/composables/useActivityIndicator"

const emit = defineEmits<{ "open-drawer": [] }>()
const route = useRoute()

const items = computed(() => buildNavigationItems())
const byRouteName = computed(() => new Map(items.value.map(i => [i.routeName, i])))

const dockSlots = computed<(NavigationItem | null)[]>(() =>
  DOCK_ROUTE_NAMES.map(name => byRouteName.value.get(name) ?? null)
)

const { communityIndicator } = useAppContext()
const communityBadge = badgeFor(communityIndicator)
</script>

<template>
  <nav
    aria-label="Mobilnavigation"
    class="dock dock-md lg:hidden"
  >
    <template
      v-for="(item, i) in dockSlots"
      :key="i"
    >
      <router-link
        v-if="item"
        v-slot="{ href, navigate, isActive }"
        :to="item.to"
        custom
      >
        <a
          :href="href"
          :class="{ 'dock-active text-primary': isActive }"
          :aria-current="isActive ? 'page' : undefined"
          :data-testid="`dock-slot-${i}`"
          @click="navigate"
        >
          <span
            v-if="item.routeName === 'community' && communityBadge"
            class="indicator"
          >
            <span
              class="indicator-item badge badge-sm"
              :class="communityBadge.color === 'error' ? 'badge-error' : 'badge-success'"
              data-testid="dock-community-badge"
            >{{ communityBadge.count }}</span>
            <svg-icon
              type="mdi"
              :path="item.icon"
              class="h-6 w-6"
              aria-hidden="true"
            />
          </span>
          <svg-icon
            v-else
            type="mdi"
            :path="item.icon"
            class="h-6 w-6"
            aria-hidden="true"
          />
          <span class="dock-label">{{ item.name }}</span>
        </a>
      </router-link>
      <span
        v-else
        :data-testid="`dock-slot-${i}`"
        aria-hidden="true"
        class="pointer-events-none cursor-default"
      />
    </template>
    <button
      type="button"
      :class="{ 'dock-active text-primary': route.name && !DOCK_ROUTE_NAME_SET.has(String(route.name)) }"
      data-testid="dock-slot-3"
      @click="emit('open-drawer')"
    >
      <svg-icon
        type="mdi"
        :path="mdiMenu"
        class="h-6 w-6"
        aria-hidden="true"
      />
      <span class="dock-label">Menü</span>
    </button>
  </nav>
</template>
